/**
 * The Floto Rooms wordmark — Floto's mark and the product name in one SVG — in
 * the header of every screen that carries the brand: home, sign-in and the
 * centered pre-work screens (see CenteredShell). One component, so the logo
 * cannot drift between them.
 */
export function BrandLockup({ className = '' }: { className?: string }) {
  return (
    <img
      alt="Floto Rooms"
      className={['h-[25px] w-auto', className].filter(Boolean).join(' ')}
      src="/icons/floto+rooms.svg"
    />
  );
}
